var Specs = new Object();
Specs.tempSpecs = new Object();
/*
NEED TO ADD REQTYPE=10 to apps
NEED TO ADD PARM TO FORCE AJAX FORMS
ADDREQTYPE code from I00010
Add use_udview to hidden fields
Add setVariables code to reports
spec object
datamodel
datamodel.fields
datamodel.keys
datamodel.fieldTypes
datamodel.sort
datamodel.fieldDescs
datamodel.fieldKeys
udfields[fieldname].fieldName
udfields[fieldname].fieldDesc
udfields[fieldname].backgroundColor
udfields[fieldname].fontColor
udfields[fieldname].columnWidth
udfields[fieldname].columnClass
udfields[fieldname].seq
*/
Specs.selectedNav = '';
var deleteFieldIcon = '<i class="fa fa-large fa-times remove-field"></i>';
jQuery(function(){
	jQuery("body").on('click','.field-options',function(){
		var button = jQuery(this);
		var formid = button.closest("form").attr('id');
		var lib = jQuery(this).attr('data-lib');
		var status = jQuery(".nav-option").length;
		if(status > 0 && (Specs.currentFormId) && Specs.currentFormId !== formid){
			var html = jQuery(".main-content").html();
			jQuery("body").html(html);
			try{jQuery('.picker').simpleColorPicker();}catch(err){}
		}
		if(status > 0 && Specs.currentFormId == formid){
			jQuery(".left-nav").toggle();
			if(jQuery(".left-nav").css('display') == 'none'){
				jQuery(".main-content").css('margin-left','0px');
				Specs.selectedNav = '';
			}else{
				jQuery(".main-content").css('margin-left','75px');
			}
		}else{
			jQuery.get(lib + '.MRCViews',function(data){
				var content = jQuery(".page-wrap");
				content.detach();
				jQuery("body").append(data);
				jQuery(".main-content").append(content);
				button.attr('data-status','open');
				loadApplication(button);
				jQuery("input[name=ajax_form]").val(1);
				try{jQuery('.picker').simpleColorPicker();}catch(err){}
			}).fail(function(){//indicate views are not yet installed for this dictionary
				alert('User Defined Application Views have not yet been installed for this dictionary. \nPlease click the "User Defined Application Views" button in the m-Power Interface via the \nAdmin --> System Management screen to install User Defined Application Views.');
			});
		}
		Specs.currentFormId = formid;
	});
	jQuery("body").delegate(".left-nav ul li.nav-option",'click',function(){
		var clickedId = jQuery(this).attr('id');
		jQuery(".nav-option").removeClass('nav-option-selected');
		showNavContainer(clickedId);
		if(Specs.selectedNav == ''){
			Specs.selectedNav = clickedId;
			showNavContainer(clickedId);
			animateNavigation();
		}else if( Specs.selectedNav == clickedId){
			showNavContainer(clickedId);
			animateNavigation();
			Specs.selectedNav = '';
			jQuery(".nav-option").removeClass('nav-option-selected');
		}else{
			Specs.selectedNav = clickedId;
		}
	});
	jQuery("body").delegate(".remove-field",'click',function(){
		var field = jQuery(this).closest("li").remove().attr('data-field');
		jQuery(".available-fields").find("li[data-field='" + field + "']").removeClass('selected-field');
		Specs.updateFieldOrder();
		if(jQuery(".selected-fields .field-li").length == 1){
			jQuery(".open-save-changes-dialog").prop('disabled',true);
		}
	});
	jQuery("body").delegate(".selected-fields li",'click',function(){
		jQuery(".selected-fields li").removeClass('highlighted');
		jQuery(this).addClass("highlighted");
		Specs.setFieldInfoInForm(jQuery(this));
		clearColorInputs();
	});
	jQuery("body").delegate(".format-fields-container input",'keyup',function(){
		var field = jQuery(".selected-fields li.highlighted").attr('data-field');
		var attr = jQuery(this).attr('data-attr');
		var value = jQuery(this).val();
		if(attr == 'fieldDesc'){
			jQuery(".selected-fields li.highlighted").find(".label").text(" (label \"" + value + "\")");
		}
		jQuery(".selected-fields li.highlighted").attr('data-' + attr,value)
		Specs.udfields[field][attr] = value;
	});
	jQuery("body").delegate(".available-fields li",'click',function(){
		var isSelected = jQuery(this).hasClass('selected-field');
		var field = jQuery(this).attr('data-field');
		var li;
		if(isSelected){
			jQuery(this).removeClass('selected-field');
			jQuery(".selected-fields li[data-field='" + field +"']").remove();
		}else{
			li = jQuery(this).clone();
			li.append(deleteFieldIcon);
			
			jQuery(".selected-fields").append(li);
			jQuery(this).addClass('selected-field');
		}
		Specs.updateFieldOrder();
		if(li){
			 Specs.applyFieldInfoToLi(li);
			 li.find(".label").text(" (label \"" + Specs.udfields[field].fieldDesc + "\")");
		}	
	});
	jQuery("body").delegate(".open-save-changes-dialog",'click',function(){
		jQuery(".save-view-popup").show();
		jQuery("#saveviewname").val('');
	});
	jQuery("body").delegate(".applychanges",'click',function(){
		jQuery(".open-save-changes-dialog").prop('disabled',false);
		var saveSpecAs = new Object();
		saveSpecAs.udfields = Specs.udfields;
		saveSpecAs.appfields = Specs.datamodel.fields;
		var jsonSpec = JSON.stringify(saveSpecAs);
		Specs.tempSpecs[Specs.currentFormId] = saveSpecAs;
		var appid = Specs.appId;
		var lib = jQuery("#currentlibrary").val();
		var run = '';
		var formname = 'FORM_' + appid.substring(0,appid.length -1 );
		//if(Specs.datamodel.appType == 'R'){
			run = '&' + jQuery("form[name='" + formname + "']").serialize();
		//}
		var url = lib + '.' + appid + '?basic=4&ajax_form=1&async=1'  + run +'&x=' + Math.random();
		var form = jQuery("#" + Specs.currentFormId);
		var parent = form.parents(".ajax_content").get(0);
		var data = {'udspecjson' :  jsonSpec}
		if(Specs.datamodel.appType == 'IRT'){
			setJsonSpecInIRT(jsonSpec,formname);
		}else{
			showLoading();
			jQuery.ajax({
				type:'POST',
				url: url,
				data: data, 
				success: function(data){
					var el = jQuery(data);
					jQuery(parent).replaceWith(el);
					hideLoading();
					initializeAjaxHelpers(el.find("form").get(0));
				}
			})
			/*jQuery.post(url,function(html){
				var el = jQuery(html);
			    jQuery(parent).replaceWith(el);
				hideLoading();
			});*/
		}
	});
	jQuery("body").delegate(".save-view",'click',function(){
		var specName = jQuery("#saveviewname").val();
		
		var appid = Specs.appId;
		var lib = Specs.lib;
		var url = lib + '.MRCViews?one_step=1&APPID=' + appid;
		var saveSpecAs = new Object();
		saveSpecAs.udfields = Specs.udfields;
		//saveSpecAs.appfields = Specs.datamodel.fields;
		var jsonSpec = JSON.stringify(saveSpecAs);
		var isDefault = jQuery("#defaultview").prop('checked');
		if(isDefault == true){
			isDefault = 1;
		}else{
			isDefault = 0;
		}
		url +=  '&DFTVIEW=' + isDefault;
		if(jQuery.trim(specName) != ''){
			for(var i in Specs.appViews){//check if name already exists
				if(specName == Specs.appViews[i].SPECNAME){
					alert('This view name (' + specName + ') already exists. Please enter a different name for this view.');
					return;
				}
			}
			url += '&action_mode=add&VIEWID=1&SPECNAME=' + specName;
		}else{
			url += '&action_mode=update';
			var selected = jQuery(".existing-view-list li.highlighted");
			if(!selected){
				showAlert('You must enter a view name or select an existing view.');
				return;
			}
			var id = selected.attr('data-id');
			var name = selected.attr('data-specname');
			url += '&VIEWID=' + id + '&SPECNAME=' + name;
			specName = name;
		}
		url += '&SVSEARCH=ud_' +specName;// +  '&SPEC=' + encodeURIComponent(jsonSpec); //post the spec as data 2016-11-30 #25285 
		url += '&x=' + Math.random();
		 
		jQuery(".save-view-popup").hide();
		if(isDefault == 1){
			removeDefaults(url,specName,jsonSpec);
		}else{
			saveApplicationView(url,specName,jsonSpec);
		}
		jQuery.ajax({url:lib + '.' + appid, 
					data:'&saveView=Y&viewName=ud_' + encodeURIComponent(specName) + '&isIRT=N&x=' + Math.random(), 
					dataType: "html",
					success:function(){
			
					}
		 });
		
	});
	jQuery("body").delegate(".field-search",'keyup',function(){
		var val = jQuery(this).val();
		jQuery(".available-fields li").filter(function(){if(jQuery(this).hasClass('model') == true){return false;}else{return true;}}).each(function(){
			var text = jQuery(this).text();
			if(val == ''){
				jQuery(this).show();
			}else if(text.toLowerCase().indexOf(val.toLowerCase()) < 0){
				jQuery(this).hide();
			}else{
				jQuery(this).show();
			}
		});
	});
});
function clearColorInputs(){
	jQuery(".picker").each(function(){
		if(jQuery(this).val() == ''){
			jQuery(this).css('background-color','#fff');
		}
	});
}
function setJsonSpecInIRT(jsonSpec,formname){
	var input = '<input type="hidden" name="udspecjson" value="' + escape(jsonSpec) + '"/>';
	var input2 = '<input type="hidden" name="use_udview" value="1"/>';
	var form = jQuery("form[name='" + formname + "']");
	form.find("input[name=udspecjson]").remove();
	form.find("input[name=use_udview]").remove();
	form.append(input);
	form.append(input2);
	form.submit();
}
function getCurrentUrl(querystring){
	var url =  window.location.toString();
	var idx = url.indexOf('?');
	if( idx > 0){
		url = url.substring(0,idx) + querystring;
	}else{
		url = url + querystring;
	}
	return url;
}
function showNavContainer(navId){
	var availableFieldsContainer = jQuery(".available-fields-container");availableFieldsContainer.hide();
	var selectFieldsContainer = jQuery(".select-fields-container");selectFieldsContainer.hide();
	var formatFieldsContainer = jQuery(".format-fields-container");formatFieldsContainer.hide();
	var savedViewsContainer = jQuery(".saved-views-container");savedViewsContainer.hide();
	
	if(navId == 'fieldsnav'){
		availableFieldsContainer.show();
		selectFieldsContainer.show();
	}else if (navId == 'formatnav'){
		formatFieldsContainer.show();
		selectFieldsContainer.show();
		if(jQuery("li.highlighted").length == 0){
			var li = jQuery(".selected-fields").find("li[data-field]:first").addClass("highlighted");
			Specs.setFieldInfoInForm(li);
		}
		clearColorInputs();
	}else if (navId == 'searchesnav'){
		savedViewsContainer.show();
	}
	jQuery("#" + navId).addClass('nav-option-selected');
}
function animateNavigation(){
	jQuery(".main-content").animate(
		{
		  marginLeft: (parseInt(jQuery(".main-content").css('margin-left'),10) == '75')? '550px': '75px'
		},500,function(){});
}

function loadApplication(button){
	var form = button.closest("form");
	var action = form.attr('action');
	var lib = button.attr('data-lib');
	var app = button.attr('data-app');
	jQuery("#currentapp").val(app);
	var specUrl = lib + '.MRCViews?pageName=MRCViews_json.html&rls_APPID=EQ&val_APPID=' + app;
	var fieldUrl = lib + "." + app + '?reqtype=10&x=' + Math.random();
	var appUrl = lib + "." + app + '';
	Specs.appId = app;
	Specs.lib = lib;
	Specs.resetInterface();
	jQuery.get(specUrl,function(viewAry){//load views
		var defaultView = Specs.processExistingViews(viewAry);
		if(defaultView && defaultView.SPECNAME){
			appUrl += '?udapplication=' + defaultView.VIEWID;
			//jQuery(".open-save-changes-dialog").prop('disabled',false);
		}
		var oldUrl =  window.location.toString();
		var saveUrl = oldUrl.substring(0,oldUrl.lastIndexOf("/") + 1) + appUrl;
		jQuery("#currenturl").val(saveUrl);
		appUrl += '&basic=4&x=' + Math.random();
		
		jQuery.get(fieldUrl,function(fieldData){//get app data model
			jQuery.extend(Specs, fieldData);
			if(Specs.tempSpecs[Specs.currentFormId] !== undefined){
				Specs.udfields = Specs.tempSpecs[Specs.currentFormId].udfields; // use data from spec instead of defaults from app
				Specs.loadSpecData(1);
			}else if(defaultView && defaultView.SPECNAME){
				var jsonSpec = defaultView.SPEC;
				var dftObj = JSON.parse(jsonSpec);
				Specs.udfields = dftObj.udfields; // use data from spec instead of defaults from app
				Specs.loadSpecData(1);
			}else{
				Specs.loadSpecData(0);
			}
			jQuery(".selected-fields").sortable({
				stop:function(){
					Specs.updateFieldOrder();
				}
			});
			//jQuery.get(appUrl,function(html){//load app
			//	jQuery(".main-content").html(html);
			//});
		});
	});
	jQuery("body").delegate(".close-dialog",'click',function(){
		jQuery(".save-view-popup").hide();
	});
	jQuery("body").delegate(".view-li",'click',function(){
		jQuery(".view-li").removeClass('highlighted');
		jQuery(this).addClass('highlighted');
		jQuery(".load-saved-view").show();
		jQuery("#saveviewname").val('');
		
	});
	jQuery("body").delegate('.load-saved-view','click',function(){
		var el = jQuery('.view-li.highlighted');
		var id = el.attr('data-id');
		var viewObj = new Object();
		for(var i in Specs.appViews){
			if(id == Specs.appViews[i].VIEWID){
				viewObj = Specs.appViews[i];
				break;
			}
		}
		var app = Specs.appId;
		var lib = Specs.lib;
		var fieldUrl = lib + "." + app + '?reqtype=10&x=' + Math.random();
		var appUrl = lib + "." + app + '?basic=4';
		var run = '';
		if(Specs.datamodel.appType == 'R'){
			run = '&run=2';
		}
		appUrl += '&udapplication=' + viewObj.VIEWID + run + '&view=ud_' + viewObj.SPECNAME + '&use_udview=1&ajax_form=1&x=' + Math.random();
		
		
		var jsonSpec = viewObj.SPEC;
		var dftObj = JSON.parse(jsonSpec);
		Specs.udfields = dftObj.udfields; // use data from spec instead of defaults from app
				
		Specs.loadSpecData(1);
		showLoading();
		jQuery.get(appUrl,function(html){//load app
			jQuery(".main-content").html(html);
			hideLoading();
		});
		var saveUrl = '?udapplication=' +  viewObj.VIEWID ;
		saveUrl = getCurrentUrl(saveUrl);
		jQuery("#currenturl").val(saveUrl);
	});
	jQuery("body").delegate(".dropdown_box",'click',function(){
		jQuery("#app_dropdown_container").toggle();
	});
	jQuery("body").delegate("#app_dropdown_container li",'click',function(e){
		var app = jQuery(this).attr('data-app');
		var text = jQuery(this).text();
		
		jQuery(".dataset").attr('data-app',app);
		jQuery("#selected_app").text(text);
		
		jQuery("#app_dropdown_container").toggle();
	});
}
jQuery("body").delegate("#loadapp",'click',function(){
	
});

function saveApplicationView(url,viewName,spec){
	var specData = new Object();
	specData.SPEC = spec;//encodeURIComponent(spec);
	//2016-11-30 #25285 save via jquery.ajax for POST
	jQuery.ajax({
		url:url,
		data:specData,
		method:'POST',
		success:function(data){
			if(url.indexOf("action_mode=add") >=0 ){
				var newID = jQuery.trim(data);
				var appUrl = '?udapplication=' + newID;
				var viewLiHtml = '<li class="view-li" data-id="' + newID + '" data-specname="' + viewName + '">' + viewName + '</li>';
				jQuery(".view-list").append(viewLiHtml);
				jQuery(".existing-view-list").append(viewLiHtml);
				var user = jQuery("#currentuser").val();
				var newViewObj = new Object();
				newViewObj.VIEWID = newID;
				newViewObj.USERID = user;
				newViewObj.SPEC = spec;
				newViewObj.SPECNAME = viewName;
				Specs.appViews.push(newViewObj);
			}
			appUrl = getCurrentUrl(appUrl)
			jQuery("#currenturl").val(appUrl);
			showAlert('View has been saved.');
		}
	});
}
function removeDefaults(saveUrl,viewName,spec){
	var lib = jQuery("#currentlibrary").val();
	var app = jQuery("#currentapp").val();
	var user = jQuery("#currentuser").val();
	var specUrl = lib + '.MRCViews?pageName=MRCViews_json.html&rls_APPID=EQ&val_APPID=' + app + '&rls_DFTVIEW=EQ&val_DFTVIEW=1&rls_USERID=EQ&val_USERID=' + user + '&x=' + Math.random();
	function callSaveView(){
		saveApplicationView(saveUrl,viewName,spec);
	}
	jQuery.get(specUrl,function(data){
		var ary = JSON.parse(data);
		if(ary.length == 0){
			callSaveView();
			return;
		}
		deleteNextDefault(0,ary,callSaveView);//mark defaults to no.
	});
}
function deleteNextDefault(index,ary,callSaveView){
	var app = jQuery("#currentapp").val();
	var lib = jQuery("#currentlibrary").val();
	var id = ary[index].VIEWID;
	var specName = ary[index].SPECNAME;
	var deleteUrl = lib + '.MRCViews?action_mode=update&work_with=2&one_step=1&SPECNAME=' + specName + '&APPID=' + app + '&VIEWID=' + id + '&DFTVIEW=0' + '&x=' + Math.random();
	jQuery.get(deleteUrl,function(data){
		index++;
		if(ary.length <= index){
			callSaveView();
		}else{
			deleteNextDefault(index,ary,callSaveView);
		}
	});
}
function showAlert(text){
	jQuery(".alert").html(text);
	jQuery(".alert").fadeIn(1000,function(){
		setTimeout(function(){jQuery(".alert").fadeOut(1000);},2000);
	});
}
function showLoading(){
	jQuery(".alert").html('<span>Loading...</span>&nbsp;&nbsp; <img src="/mrcjava/image/ajax-loader.gif"/>');
	jQuery(".alert").fadeIn(1000);
}
function hideLoading(){
	jQuery(".alert").fadeOut(1000);
}
Specs.resetInterface = function(){
	delete this.udfields;
	delete this.datamodel;
	jQuery(".field-li,.view-li").each(function(){
		if(jQuery(this).hasClass("model") == false){
			jQuery(this).remove();
		}
	});
};
Specs.loadSpecData = function(dft){
	this.loadAvailableFields(dft);
};
Specs.loadAvailableFields = function(dft){
	var datamodel = this.datamodel;
	var udfields = this.udfields;
	var fieldSequence = new Object();
	jQuery(".available-fields li[data-field],.selected-fields li[data-field]").remove();//remove existing
	for(var i = 0;i < datamodel.fields.length;i++){
		if(datamodel.displayFields[i] == "0"){
			continue;
		}
		var model = jQuery(".available-fields li.model").clone();
		var field = datamodel.fields[i];
		var desc = datamodel.fieldDescs[i];
		if(field != desc){
			desc = ' - ' + desc;
		}else{
			desc = '';
		}
		model.removeClass("model").attr('data-field',field).prepend(field + desc);
		model = Specs.applyFieldInfoToLi(model);
		jQuery(".available-fields").append(model);
		var fieldName = datamodel.fields[i]
		if(udfields[fieldName]){
			fieldSequence[udfields[fieldName].seq] = fieldName;
		}
	}
	if(dft == 0){//there is no default, load no fields
		return;
	}
	var next = true;
	var idx = 0;
	while(next == true){
		if(fieldSequence[idx]){
			var field = fieldSequence[idx];
			var model = jQuery(".available-fields li[data-field='" + field + "']");
			//model = Specs.applyFieldInfoToLi(model);
			model = model.addClass('selected-field').clone().removeClass('selected-field');
			model.append(deleteFieldIcon);
		
			model.find(".label").text(" (label \"" + udfields[field].fieldDesc + "\")");
			jQuery(".selected-fields").append(model);
		}else{
			next = false;
		}
		idx++;
	}
	
};
Specs.checkIsKey = function(field){
	var keys  = this.datamodel.keys;
	for(var i in keys){
		if(keys[i] == field){
			return true;
		}
	}
	return false;
};
Specs.processExistingViews = function(jsonStr){
	var viewAry = new Array();
	try{
		viewAry = JSON.parse(jsonStr);
		Specs.appViews = viewAry;
		var defaultView;
		var foundUserDefault = false;
		var urlView = getURLParm('udapplication');
		for(var i in viewAry){
			var li = jQuery(".view-list li.model").clone();
			li.removeClass("model");
			li.text(viewAry[i].SPECNAME);
			li.attr('data-id',viewAry[i].VIEWID);
			li.attr('data-specname',viewAry[i].SPECNAME);
			jQuery(".view-list").append(li);
			var li2 = li.clone();
			if(viewAry[i].USERID != ''){
				jQuery(".existing-view-list").append(li2);
			}
			if(viewAry[i].VIEWID == urlView){
				jQuery(".view-list li").removeClass('highlighted');
				li.addClass('highlighted');
				defaultView = viewAry[i];
				foundUserDefault =  true;
			}else if(viewAry[i].DFTVIEW == 1 && foundUserDefault == false){
				jQuery(".view-list li").removeClass('highlighted');
				li.addClass('highlighted');
				defaultView = viewAry[i];
				if(viewAry[i].USERID != ''){
					foundUserDefault =  true;
				}
			}
		}
		return defaultView;
	}catch(err){}
};
Specs.applyFieldInfoToLi = function(li){
	var udfields = this.udfields;
	var datamodel = this.datamodel;
	var field = li.attr('data-field');
	var fieldObj = udfields[field];
	if(!fieldObj){
		var idx= getFieldIndex(datamodel.fields,field);
		fieldObj = new Object();
		fieldObj.fieldDesc = datamodel.fieldDescs[idx];
	}
	li.attr({
		"data-fieldDesc":fieldObj.fieldDesc,
		"data-fontColor":fieldObj.fontColor,
		"data-backgroundColor":fieldObj.backgroundColor,
		"data-columnWidth":fieldObj.columnWidth,
		"data-columnClass":fieldObj.columnClass
	});
	
	return li;
};
function getFieldIndex(fields, fieldName){
	for(var i in fields){
		if(fieldName == fields[i]){
			return i;
		}
	}
}
Specs.setFieldInfoInForm = function(li){
	jQuery("#fieldlabel").val(li.attr('data-fieldDesc'));
	jQuery("#fieldwidth").val(li.attr('data-columnWidth'));
	jQuery("#fontcolor").val(li.attr('data-fontColor'));
	jQuery("#backgroundcolor").val(li.attr('data-backgroundColor'));
	jQuery("#conditionalstyling").val(li.attr('data-columnClass'));
	return li;
};
Specs.updateFieldOrder = function(){
	var udfields = this.udfields;
	var i = this.datamodel.keys.length ; // this was 0
	var fieldAry = new Array();
	var keySeq = 0;
	jQuery(".selected-fields li[data-field]").each(function(){
		var li = jQuery(this);
		var field = li.attr('data-field');
		fieldAry.push(field);
		 if(udfields[field]){
			if(Specs.checkIsKey(field) == true){
				udfields[field].seq = keySeq;
				keySeq++;
			}else{
				udfields[field].seq = i;
				i++;
			}
		 }else{
			udfields[field] = new Object();
			udfields[field].seq = i;
			var fieldDesc = li.attr('data-fieldDesc');
			udfields[field].fieldDesc = fieldDesc;
			var fieldName = li.attr('data-field');
			udfields[field].fieldName = fieldName;
			var width = li.attr('data-columnWidth');
			udfields[field].columnWidth = width;
			var fontColor = li.attr('data-fontColor');
			udfields[field].fontColor = fontColor;
			var bgColor = li.attr('data-backgroundColor');
			udfields[field].backgroundColor = bgColor;
			var columnClass = li.attr('data-columnClass'); 
			udfields[field].columnClass = columnClass;
			i++;
		 }
		 
	});
	for(var j =0;j < this.datamodel.fields.length;j++){
		var field = this.datamodel.fields[j];
		if(udfields[field]){
			var foundField = false;
			for(var i in fieldAry){
				if(fieldAry[i]  == field){
					foundField = true;
					break;
				}
			}
			if(foundField == false){
				delete udfields[field];
			}
		}
		
	}
};
Specs.saveCurrentSpec = function(specname,isExisting){
//	var app = jQuery(".dataset").attr('data-app');
};
function getURLParm(name) {
    return decodeURIComponent(
        (RegExp(name + '=' + '(.+?)(&|$)').exec(location.search)||[,null])[1]
    );
}
function setUniqueId(button){
	var id = Math.random();
	id= id.toString();
	var existingId = button.attr('data-id');
	if(!existingId || existingId == ''){
		id = id.substring(id.indexOf('.') + 1);
		button.attr('data-id',id);
		return id;
	}else{
		return existingId;
	}
}